import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../services/ssession.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [],
  template: ''
})
export class LoginComponent implements OnInit {

  private router: Router = inject(Router);

  private route: ActivatedRoute = inject(ActivatedRoute);

  public ngOnInit(): void {
    const token = this.route.snapshot.queryParams['token'];
    if (token) {
      SessionService.SetAccessToken(token);
    }
    const callBack = this.route.snapshot.queryParams['callBack'];
    this.router.navigate([callBack || 'strona-glowna'], {
      queryParams: {
        ...this.route.snapshot.queryParams,
        token: undefined,
        callBack: undefined,
        embed: undefined
      }
    }).then(() => location.reload());
  }
}
